import { cva } from 'class-variance-authority';

var clazz = cva("group/option flex items-center w-full h-fit min-h-[42px] px-2 py-[2px] select-none outline-none ring-0", {
    variants: {},
    compoundVariants: [],
    defaultVariants: {}
});
var subclazz = cva("flex items-center w-full h-fit min-h-[42px] p-2 rounded-lg overflow-hidden", {
    variants: {
        disabled: {
            false: "group-focus-visible/option:bg-blue-306 group-hover/option:bg-blue-306",
            true: "bg-gray-cool-100 pointer-events-none"
        },
        selected: {
            true: "bg-blue-307"
        }
    },
    compoundVariants: [],
    defaultVariants: {
        disabled: false,
        selected: false
    }
});

export { clazz, subclazz };
